import {AfterViewInit, Component, EventEmitter, OnDestroy, Output, ViewChild} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import * as Moment from 'moment';
import {BehaviorSubject, of, Subject} from 'rxjs';
import {debounceTime, take, takeUntil} from 'rxjs/operators';
import {DateMoreThan} from '../../../../../shared/custom-validations/date-validations';
import {FusionAuthService} from '../../../../../shared/services/fusion-auth';
import {ClientSelectorComponent} from '../../../../shared/components/client-selector/client-selector.component';
import {Unit} from '../../../../shared/models/order-entry/unit';
import {ClientService} from '../../../../shared/services';

function today() {
  return Moment().format('MM/DD/YYYY');
}

@Component({
  selector: 'app-requisition-search',
  templateUrl: './requisition-search.component.html',
  styleUrls: ['./requisition-search.component.scss'],
})
export class RequisitionSearchComponent implements AfterViewInit, OnDestroy {
  @ViewChild(ClientSelectorComponent, {static: true}) public clientSelector?: ClientSelectorComponent;
  public requisitionSearchForm: UntypedFormGroup;
  public role: string;
  private sent = false;
  @Output() public formSubmitted = new EventEmitter();
  private onDestroy$ = new Subject();
  // @ts-ignore
  public unitDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(undefined);

  constructor(private fb: UntypedFormBuilder, private fusionAuthService: FusionAuthService, private clientService: ClientService) {
    this.requisitionSearchForm = this.fb.group({
      startDate: [today(), [Validators.required]],
      endDate: [today(), [Validators.required, DateMoreThan('startDate')]],
      client: [null],
      unit: [null],
      patient: [null],
      status: [null],
      signature: [null],
    });

    this.role = fusionAuthService.Profile.registrations[0].roles[0];
  }

  public convertToFormControl(absCtrl: AbstractControl | null): UntypedFormControl {
    return absCtrl as UntypedFormControl;
  }

  public ngAfterViewInit(): void {
    of(null)
      .pipe(
        take(1),
        debounceTime(2000),
      )
      .subscribe(() => {
        if (!this.sent) {
          this.submit();
          this.sent = true;
        }
        this.requisitionSearchForm.get('client')?.valueChanges
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(client => {
            if (client) {
              this.unitDataSource.next(new DataSource({
                store: this.clientService.clientUnitsCustomStore(client.id, this.unitDataSource),
              }));
            } else {
              // @ts-ignore
              this.unitDataSource.next(undefined);
            }
          });
      });
  }

  public clear() {
    this.requisitionSearchForm.reset();
    this.submit();
  }

  public searchRequisitions(): void {
    if (this.requisitionSearchForm.valid) {
      this.submit();
    }
  }

  private submit() {
    if (!this.requisitionSearchForm.get('startDate')?.value) {
      this.requisitionSearchForm.get('startDate')?.setValue(today());
    }

    if (!this.requisitionSearchForm.get('endDate')?.value) {
      this.requisitionSearchForm.get('endDate')?.setValue(today());
    }

    this.formSubmitted.emit(this.requisitionSearchForm.value);
  }


  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
